<div class="container">
    <div *ngIf="loadProducts" id="loadingPage"></div>
    <div class="row fam" *ngIf="!loadProducts">
        <div class="col-xs-6 fam-c" *ngFor="let product of products;let i=index">
            <product [product]="product">
            </product>
        </div>
    </div>
    <div>
        <div class="alert alert-danger text-center" *ngIf="!loadProducts && family.id && products.length==0">
            Produit non disponible
            <ng-container *ngIf="orderType==1">en livraison</ng-container>
            <ng-container *ngIf="orderType==3">à emporter</ng-container>
            <ng-container *ngIf="orderType==2">sur place</ng-container>
        </div>
    </div>
</div>